import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navigation = () => {
  const { t, direction } = useLanguage();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/pos', label: t('nav.posDevices') },
    { path: '/wallet', label: t('nav.wallet') },
    { path: '/who-is-roya-for', label: t('nav.whoIsRoyaFor') },
    { path: '/about', label: t('nav.about') },
    { path: '/contact', label: t('nav.contact') },
  ];

  return (
    <nav
      className={`fixed top-0 ${direction === 'rtl' ? 'right-0 left-0' : 'left-0 right-0'} z-50 transition-all duration-300`}
      style={{
        padding: isScrolled ? '0.5rem 1rem' : '1rem',
      }}
    >
      <div
        className="nav-header max-w-7xl mx-auto"
        style={{
          borderRadius: isScrolled ? '12px' : '9999px',
        }}
      >
        {/* ROYA Logo - New Design */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src="https://customer-assets.emergentagent.com/job_a49fc96e-c6d1-4538-8241-3e5dffe114fb/artifacts/6uiz1cw4_WhatsApp%20Image%201447-06-18%20at%2008.46.59.jpeg"
            alt="ROYA"
            style={{
              height: '40px',
              width: 'auto',
              objectFit: 'contain',
              transition: 'transform 0.2s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'text-primary' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          
          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="sm"
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden mt-2 mx-4 bg-white/95 backdrop-blur-lg rounded-xl border border-gray-200 shadow-lg overflow-hidden">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-4 py-3 hover:bg-gray-50 transition-colors ${
                location.pathname === link.path ? 'bg-green-50 text-green-600 font-medium' : 'text-gray-700'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navigation;
